import React from 'react'

export default function ShareSmall(props) {
  return (
    <svg
      width={17}
      height={17}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.00601 8.67831V12.6783C3.00601 13.507 3.67801 14.1783 4.50601 14.1783H12.506C13.334 14.1783 14.006 13.507 14.006 12.6783V8.67831'
        stroke='currentColor'
      />
      <path d='M8.50598 12.6784V2.67838' stroke='currentColor' strokeWidth={1.03448} />
      <path d='M11.6883 5.90102L8.5063 2.71902L5.32364 5.90102' stroke='currentColor' />
    </svg>
  )
}
